module.exports = {
  email: 'sharma.hemang@outlook.com',

  socialMedia: [
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/sharmahemang',
    },
    {
      name: 'GitHub',
      url: 'https://github.com/hemangsharma',
    },
    {
      name: 'Other',
      url: 'https://unit.link/tribunalwolf',
    },
    {
      name: 'Calendly',
      url: 'https://calendly.com/sharma-hemang/meet',
    },
  ],

  navLinks: [
    { name: 'About', url: '/about' },
    { name: 'Experience', url: '/experience' },
    { name: 'Projects', url: '/projects' },
    { name: 'Publications', url: '/publications' },
    { name: 'Certificates', url: '/certificates' },
    { name: 'Contact', url: '/contact' },
  ],

  colors: {
    green: '#64ffda',
    navy: '#0a192f',
    darkNavy: '#020c1b',
    lightblack: '#101010',
    beige: '#f0e6d2',
    sydneyblue: '#00b5e2',
    darkgrey: '#343a40',
    night: '#111111',
    lightgrey: '#f8f9fa',
    white: '#ffffff',
    black: '#000000',
  },

  srConfig: (delay = 10, viewFactor = 0.1) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'once',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
